import {
  IViewMorePrivateClassBackEndModel,
  IPrivateClassViewMoreFrontEndModel,
  TeacherDetailTypeEnum,
} from "../types";

export const parseToPrivateClassViewMoreFrontEndModel = (
  privateClass: IViewMorePrivateClassBackEndModel,
): IPrivateClassViewMoreFrontEndModel => {
  const details: { name: string; content: string; type: number }[] = [];

  if (privateClass.teacher.bio) {
    details.push({
      name: "Bio",
      content: privateClass.teacher.bio,
      type: TeacherDetailTypeEnum.Bio,
    });
  }

  if (privateClass.teacher.education) {
    details.push({
      name: "Education",
      content: privateClass.teacher.education,
      type: TeacherDetailTypeEnum.Education,
    });
  }

  if (privateClass.teacher.experience) {
    details.push({
      name: "Experience",
      content: privateClass.teacher.experience,
      type: TeacherDetailTypeEnum.Experience,
    });
  }

  if (privateClass.teacher.calendar) {
    details.push({
      name: "Calendar",
      content: privateClass.teacher.calendar,
      type: TeacherDetailTypeEnum.Calendar,
    });
  }

  return {
    id: privateClass.id,
    teacherId: privateClass.teacherId,
    subjectName: privateClass.subjectName,
    teachingLanguage: privateClass.teachingLanguage,
    description: privateClass.description,
    extraFiles: privateClass.extraFiles,
    teacher: privateClass.teacher,
    details,
  };
};
